module.exports = __webpack_public_path__ + "static/2021_VikidzLogo-570fa6e760c4863633b16f1c2c2d5384.png";